import { observable, bindable } from 'aurelia-framework';
import { SizeUtility } from '_controls/size-utility';

export class SearchDdl {

    private _sizeUtil: SizeUtility;

    constructor() {
        this._sizeUtil = new SizeUtility();
    }
    
    @bindable @observable searchText: string;
    @bindable isOpen = false;
    @bindable isFocused = false;

    dialogWidth = '500px';

    attached() {
        this.dialogWidth = this.calculateDialogWidth();
        window.onresize = () => {
            this.dialogWidth = this.calculateDialogWidth();
        };
    }

    calculateDialogWidth() {
        return (this._sizeUtil.calculateWindowWidth() - 25).toString() + 'px';
    }

    searchToggled() {
        var isOpening = !this.isOpen;
        this.isFocused = isOpening;

        if (isOpening) {
            this.subscribeToKeyEvents();
        } else {
            this.unsubscribeToKeyEvents();
        }
    }

    clearSearch() {
        this.searchText = '';
    }

    subscribeToKeyEvents() {
        window.addEventListener('keypress', this.onKeyPress, false);
    }

    unsubscribeToKeyEvents() {
        window.removeEventListener('keypress', this.onKeyPress);
    }

    // NOTE: Using lambda syntax captures "this" in a closure
    onKeyPress = (e: KeyboardEvent) => {
        if (e.keyCode == 13) {
            // enter
            this.isOpen = false;
        }
    };
}